"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "draftShopperData", {
  enumerable: true,
  get: function get() {
    return _draftShopperData["default"];
  }
});
Object.defineProperty(exports, "notifications", {
  enumerable: true,
  get: function get() {
    return _notifications["default"];
  }
});
exports.shopperData = exports.data = void 0;

var _draftShopperData = _interopRequireDefault(require("./draft-shopper-data"));

var _notifications = _interopRequireDefault(require("./notifications"));

var _global = require("./global");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Create a frozen shallow copy of window.ux.data
var _data = (0, _global.get)('window', 'ux.data');

var data = _data && Object.freeze(_objectSpread({}, _data)); // Expose the Shopper Data API


exports.data = data;
var shopperData = (0, _global.get)('window', 'ux.eldorado.shopperData');
exports.shopperData = shopperData;